// eslint-disable-next-line import/no-anonymous-default-export
export default {
  common: {
    search: 'Szukaj',
    yes: 'Tak',
    no: 'Nie',
    ok: 'OK',
    nok: 'NOK',
    email: 'Adres e-mail',
    cancel: 'Anuluj',
    close: 'Zamknij',
    save: 'Zapisz',
    edit: 'Edytuj',
    date: 'Data',
    time: 'Godzina',
    date_from: 'Data od',
    date_to: 'Data do',
    today: 'Dzisiaj',
    last_seven_days: 'Ostatnie 7 dni',
    clear: 'Wyczyść',
    min: 'Min',
    max: 'Max',
    export: 'Eksportuj',
    add: 'Dodaj',
    delete: 'Usuń',
    tag: 'Tag/Atrybut',
    name: 'Nazwa',
    actions: 'Akcje',
    confirm: 'Potwierdź',
    select: 'Wybierz',
    confirm_delete_message: 'Czy na pewno chcesz usunąć <0>{{name}}</0>?',
    error_name_required: 'Nazwa jest wymagana',
    continue: 'Kontynuuj',
    kilograms: 'Kilogramy',
    grams: 'Gramy',
    no_tag: 'Brak Taga',
    active: 'Aktywny',
    inactive: 'Nieaktywny',
    details: 'Szczegóły',
    type: 'Typ',
    print: 'Drukuj',
    preview: 'Podgląd',
    start: 'Uruchom',
    resume: 'Wznów',
    redo: 'Ponów',
    pause: 'Wstrzymaj',
    stop: 'Zatrzymaj',
    choosen_items: 'wybrane elementy',
    filter: 'Filtruj',
    selected_label: 'Zaznaczono: {0}',
    version: 'Wersja',
  },
  measurements: {
    header: 'Pomiary',
    empty_message: 'Brak pomiarów dla podanej wagi',
    value: 'Wartość',
    time: 'Czas pomiaru',
    table_footer: 'Widoczne {first} do {last} z {totalRecords} pomiarów',
  },
  login_page: {
    header: 'SCALESCLOUD.COM',
    subheader: 'Logowanie do systemu',
    password: 'Hasło',
    login: 'Zaloguj',
    empty_email_error: 'Adres e-mail jest wymagany.',
    invalid_email_error: 'Nieprawidłowy format adresu e-mail.',
    password_error: 'Hasło jest wymagane.',
    invalid_credentials_error: 'Nieprawidłowy adres e-mail i/lub hasło.',
    other_error: 'Wystąpił nieoczekiwany błąd',
    register: 'Zarejestruj się',
    forgot_password: 'Nie pamiętasz hasła?',
    no_account: 'Nie posiadasz konta?',
  },
  register_dialog: {
    email: 'Adres e-mail',
    password: 'Hasło',
    header: 'Rejestracja użytkownika',
    set_password_header: 'Ustaw nowe hasło',
    newsletter_option: 'Zapisz się na newsletter i bądź na bieżąco z nowościami',
    empty_email_error: 'E-mail jest wymagany',
    incorrect_email_error: 'Niepoprawny adres e-mail',
    email_already_in_use: 'Podany adres e-mail jest już w użyciu',
    empty_password_error: 'Hasło jest wymagane',
    password_requirements_not_fulfilled_error:
      'Hasło musi mieć co najmniej 8 znaków, zawierać przynajmniej jedną cyfrę, dużą i małą literę oraz znak specjalny',
    confirmed_password_required: 'Potwierdzenie hasła jest wymagane',
    confirmed_password_error: 'Hasła nie są takie same',
    register: 'Zarejestruj się',
    confirm_password: 'Potwierdź hasło',
    accept_terms: 'Akceptuję regulamin',
    terms_required: 'Zaakceptowanie regulaminu jest wymagane',
    email_already_exists_error: 'Adres email jest już w użyciu',
  },
  confirmation_dialog: {
    header: 'Potwierdzenie rejestracji',
    confirmation_code: 'Kod aktywacyjny',
    confirm: 'Potwierdź',
    send_again: 'Wyślij ponownie kod aktywacyjny',
    confirmation_code_required: 'Kod aktywacyjny jest wymagany',
    confirmation_code_error: 'Kod aktywacyjny jest niepoprawny',
    confirmation_code_expired: 'Kod aktywacyjny wygasł',
    user_not_found_error: 'Nie znaleziono użytkownika z podanym adresem email',
    send_code_info:
      'Na podany podczas rejestracji adres mailowy: <bold>{{email}}</bold> został wysłany mail z kodem aktywacyjnym. Aby móc aktywować swoje konto, wprowadź kod poniżej.',
  },
  password_recovery_dialog: {
    header: 'Resetowanie hasła',
    description:
      'Jeżeli nie pamiętasz hasła, wpisz adres e-mail, na który zostało zarejestrowane konto, w celu weryfikacji...',
  },
  confirm_password_recovery_dialog: {
    header: 'Potwierdzenie resetowania hasła',
  },
  scale_chart: {
    header: 'Wykres dla wagi',
    kilograms: 'Kilogramy',
    last_thirty_one_days: 'Ostatnie 31 dni',
  },
  changes_of_states: {
    status_start: 'Początek',
    status_end: 'Koniec',
    status: 'Status',
    state: 'Stan',
    value: 'Wartość',
    changes_of_states_list: 'Lista zmian stanów',
    empty_message: 'Brak pomiarów zmian stanów',
    changes_of_states_file_name_report: 'lista_zmian_stanow_raport',
    turn_on: 'Włączone',
    turn_off: 'Wyłączone',
    toast_saved: 'Pomyślnie zapisano konfigurację',
    positive: 'Dodatnia',
    negative: 'Ujemna',
  },
  app_labels: {
    weighing_list: 'Lista ważeń',
    changes_of_states: 'Zmiany stanów',
    scale_chart: 'Wykres wagi',
    config: 'Konfiguracja',
    dosage: 'Dozowanie',
    main_page: 'Strona Główna',
    scales: 'Wagi',
    reports: 'Raporty',
    change_of_state_report: 'Raport zmiany stanów',
    suppliers: 'Dostawcy',
    suppliers_list: 'Lista dostawców',
    measurements: 'Pomiary',
    scales_indications: 'Wskazania wag',
    auto_weighings: 'Automatyczne ważenia',
    hosts: 'Hosty',
    io: 'I/O',
    administration: 'Administracja',
    measurements_series: 'Serie ważeń',
    animals: 'Zwierzęta',
    scales_indications_dashboard: 'Dashboard wskazań wag',
  },
  formats: {
    date_format: 'dd.MM.yyyy',
    hour_format: 'HH:mm',
    full_format: 'dd.MM.yyyy HH:mm:ss',
  },
  receptions_records: {
    kilograms: 'Kilogramy',
    suppliers_list: 'Lista dostawców',
    suppliers_list_report: 'lista_dostawcow_raport',
    last_day: 'Ostatni dzień',
    empty_message: 'Brak ważeń',
    supplier_name: 'Dostawca',
    receptions_number: 'Ilość ważeń',
    supplier_id: 'ID Dostawcy',
    scale_id: 'ID Wagi',
  },
  dashboard: {
    header: 'Dashboard',
    description: 'Opis',
    welcome: 'Witaj ',
  },
  scales_indications: {
    save_scale_indication: 'Wykonaj ważenie',
    save_scale_indication_and_print: 'Wykonaj i wydrukuj ważenie',
    tare: 'Taruj',
    zero: 'Zeruj',
    reconnect: 'Odśwież połączenie',
    scale: 'Waga',
    available_scales: 'Dostępne wagi',
    scale_indication: 'Wskazanie wagi',
    empty_message: 'Nie wybrano wag',
    scale_id: 'ID Wagi',
    selected_scales: 'Wybrane wagi',
    no_scales_indications_config: 'Brak wskazań wag',
    date: 'Data wskazania',
    toast_saved: 'Pomyślnie zapisano wskazanie wagi',
    toast_saved_and_printed: 'Pomyślnie zapisano oraz wydrukowano wskazanie wagi',
    toast_zero: 'Wysłano komendę zerowania do wagi',
    toast_tare: 'Wysłano komendę tarowania do wagi',
    toast_reconnect: 'Wysłano komendę odświeżenia połączenia do wagi',
    toast_save_measurement: 'Wysłano komendę wykonania pomiaru do wagi',
    toast_save_measurement_and_print: 'Wysłano komendę wykonania pomiaru i wydruku do wagi',
    success: 'Sukces',
    success_details: 'Komenda została poprawnie wykonana',
    error: 'Błąd',
    errors: {
      TIMEOUT: 'Przekroczono limit czasu na odpowiedź wagi',
      CONNECTION_REFUSED: 'Nie udało się nawiązać połączenia z wagą',
      SCALE_NOT_FOUND: 'Nie istnieje aktywne połączenie z podaną wagą',
      INVALID_RESPONSE: 'Waga nie odpowiedziała poprawnie na komendę',
      UNKNOWN_ERROR: 'Nieznany błąd',
      SERVER_TIMEOUT: 'Przekroczono limit czasu na odpowiedź hosta',
    },
  },
  weighings_list: {
    header: 'Lista ważeń',
    scale: 'Waga',
    indication: 'Wskazanie',
    alibi: 'Alibi',
    select_tag: 'Wybierz Tag/Atrybut',
    selected_tags: 'Wybrane tagi',
    weighings_list_report: 'lista_wazen_raport',
    empty_message: 'Brak ważeń',
    delete_info: 'Pomyślnie usunięto wskazanie wagi',
    print: 'Pomyślnie zakończono drukowanie',
    confirm_delete_message: 'Czy na pewno chcesz usunąć wskazanie wagi z <0>{{date}}</0>?',
  },
  auto_weighings: {
    header: 'Automatyczne ważenia',
    second: 'Sekunda',
    minute: 'Minuta',
    hour: 'Godzina',
    day: 'Dzień',
    month: 'Miesiąc',
    interval_unit: 'Jednostka interwału',
    interval_unit_value: 'Wartość interwału',
    start_from: 'Rozpocznij od',
    turn_on: 'Włącz',
    turn_off: 'Wyłącz',
    no_data: 'Brak automatycznych ważeń',
    unsaved_changes: 'Uwaga! Masz niezapisane zmiany, czy na pewno chcesz opuścić stronę?',
    header_change_of_state: 'Konfiguracja zmian stanów',
    positive_state: 'Dodatnia zmiana stanu',
    negative_state: 'Ujemna zmiana stanu',
    time_interval: 'Interwał czasowy',
    select_time_interval: 'Wybierz interwał czasowy',
    two_minutes: 'Dwie minuty',
    five_minutes: 'Pięć minut',
    ten_minutes: 'Dziesięć minut',
    min_indication_change: 'Minimalna zmiana wskazania',
    max_acceptable_deviation: 'Maksymalne akceptowalne odchylenie',
    min_indication_change_required: 'Minimalna zmiana wskazania jest wymagana',
    max_acceptable_deviation_required: 'Maksymalne akceptowalne odchylenie jest wymagane',
    config_enabled: 'Konfiguracja włączona',
    toast_saved: 'Pomyślnie zapisano konfigurację automatycznych ważeń',
    toast_added: 'Pomyślnie dodano konfigurację automatycznego ważenia',
    toast_deleted: 'Pomyślnie usunięto konfigurację automatycznego ważenia',
    auto_weighings_info: 'Konfiguracja automatycznych ważeń',
  },
  scales: {
    header: 'Wagi',
    description: 'Opis',
    empty_message: 'Brak wag spełniających podane kryteria.',
    scale_details: 'Szczegóły wagi',
    error_name_already_taken: 'Istnieje już waga z podaną nazwą.',
    error_ip_address_already_taken: 'Istnieje już waga z podanym adresem IP i portem dla danego hosta.',
    error_port_path_already_taken: 'Istnieje już waga z podanym portem dla danego hosta.',
    error_different_host: 'Powiązane urządzenia i waga muszą być przypisane do tego samego hosta.',
    host: 'Host',
    model: 'Model',
    connection_type: 'Typ połączenia',
    communication_mode: 'Tryb komunikacji',
    ip_address: 'Adres IP',
    port: 'Port',
    port_path: 'Adres portu',
    baud_rate: 'Szybkość transmisji',
    hosts_empty_message: 'Brak aktywnych hostów w systemie',
    error_model_required: 'Model jest wymagany',
    error_connection_type_required: 'Typ połączenia jest wymagany',
    error_communication_mode_required: 'Tryb komunikacji jest wymagany',
    error_host_required: 'Host jest wymagany',
    error_invalid_ip_address: 'Nieprawidłowy adres IP',
    error_ip_address_required: 'Adres IP jest wymagany',
    error_port_required: 'Port jest wymagany',
    error_port_path_required: 'Adres portu jest wymagany',
    error_baud_rate_required: 'Sybkość transmisji jest wymagana',
    send_groupped: 'Grupuj wysyłane pomiary',
    send_interval: 'Interwał wysyłania pomiarów (w sekundach)',
    error_send_interval_required: 'Czas wysyłania pomiarów jest wymagany',
    weighing_unit: 'Jednostka pomiaru',
    measurement_accuracy: 'Dokładność pomiaru',
    measurement_regex: 'Regex dla pomiaru',
    error_measurement_regex: "Regex powinien zawierać grupę 'measurement'",
    error_weighing_unit_required: 'Jednostka pomiaru jest wymagana',
    error_measurement_accuracy_required: 'Dokładność pomiaru jest wymagana',
    toast_saved: 'Pomyślnie zapisano dane wagi',
    toast_added: 'Pomyślnie dodano wagę',
    toast_deleted: 'Pomyślnie usunięto wagę',
    division: 'Oddział',
    error_division_required: 'Oddział jest wymagany',
    enums: {
      TRIGGERED_BY_US: 'Pytanie wagi o pomiary',
      TRIGGERED_BY_SCALE: 'Pomiary wysyłane z wagi',
    },
    printer: 'Drukarka',
    groups: 'Grupy',
    select_groups: 'Wybierz grupy',
    error_in_use_or_multiple_dosage: 'Grupa została przypisana do innej wagi lub wybrano dwie grupy typu dozowanie',
  },
  hosts: {
    header: 'Hosty',
    description: 'Opis',
    active: 'Aktywny',
    inactive: 'Niektywny',
    empty_message: 'Brak hostów spełniających podane kryteria.',
    host_details: 'Szczegóły hosta',
    error_name_already_taken: 'Istnieje już host z podaną nazwą.',
    activation: 'Aktywacja hosta',
    host_successfully_activated: 'Host został pomyślnie aktywowany',
    code: 'Kod hosta',
    activation_otp: 'Kod aktywacyjny',
    activation_code_info: 'Kod aktywacji wygasa po uplynięciu 15 minut.',
    toast_saved: 'Pomyślnie zapisano dane hosta',
    toast_added: 'Pomyślnie dodano hosta',
    toast_deleted: 'Pomyślnie usunięto hosta',
    division: 'Oddział',
    error_division_required: 'Oddział jest wymagany',
  },
  divisions: {
    header: 'Oddziały',
    empty_message: 'Brak oddziałów spełniających podane kryteria.',
    division_details: 'Szczegóły oddziału',
    error_name_already_taken: 'Istnieje już oddział z podaną nazwą.',
    unable_delete_division: 'Oddział nie może zostać usunięty.',
    members: 'Członkowie',
    error_invalid_user: 'Podane adresy nie istnieją w systemie',
    available_divisions: 'Dostępne oddziały',
    selected_divisions: 'Wybrane oddziały',
  },
  hooks: {
    unsaved_changes_confirmation_message: 'Masz niezapisane zmiany. Czy chcesz kontynuować?',
  },
  users: {
    header: 'Użytkownicy',
    user_details: 'Szczegóły użytkownika',
    email: 'Adres email',
    id: 'Identyfikator',
    first_name: 'Imię',
    last_name: 'Nazwisko',
    role: 'Rola',
    readonly: 'Tylko do odczytu',
    write_access: 'Prawa zapisu',
    error_email_already_taken: 'Istnieje już użytkownik z podanym emailem.',
    error_invalid_admin_domain: 'Użytkownik w podanej domenie nie może zostać przypisany do roli admina',
    error_role_required: 'Wybierz rolę użytkownika',
    error_email_required: 'Email jest wymagany',
    users_empty_message: 'Brak użytkowników spełniających podane kryteria.',
    log_out: 'Wyloguj',
    change_password: 'Zmień hasło',
    password: 'Hasło',
    password_repeat: 'Powtórz hasło',
    old_password: 'Stare hasło',
    password_change: 'Zmiana hasła',
    password_successfully_changed: 'Pomyślnie zmieniono hasło',
    error_invalid_password: 'Nieprawidłowe hasło',
    toast_saved: 'Pomyślnie zapisano dane użytkownika',
    toast_added: 'Pomyślnie dodano użytkownika',
    toast_deleted: 'Pomyślnie usunięto użytkownika',
    invalid_email_error: 'Nieprawidłowy format adresu email.',
    language: 'Język',
    languages: {
      en: 'Angielski',
      pl: 'Polski',
    },
  },
  measurementsSeries: {
    header: 'Serie ważeń',
    header_singular: 'Seria ważeń',
    open_header: 'Aktywne serie ważeń',
    closed_header: 'Zakończone serie ważeń',
    empty_message: 'Brak serii spełniających podane kryteria.',
    created_at: 'Data rozpoczęcia',
    closed_at: 'Data zakończenia',
    measurements_series_details: 'Szczegóły serii ważeń',
    open: 'Otwarte',
    closed: 'Zamknięte',
    auto_measurements: 'Automatyczne ważenie',
    begin_series: 'Rozpocznij serię',
    name: 'Nazwa serii',
    description: 'Opis serii',
    close: 'Zakończ',
    confirm_close_message: 'Czy na pewno chcesz zakończyć <0>{{name}}</0>?',
    series_accusative: 'serię',
    auto_weighing_required: 'Automatyczne ważenie jest wymagane',
    report_name: 'seria_wazen_raport',
    auto_weighing_config_tag: 'Tag',
    auto_weighing_no_data: 'Brak automatycznych ważeń',
  },
  roles: {
    header: 'Role',
    name: 'Nazwa',
    permissions: 'Uprawnienia',
    available: 'Dostępne',
    selected: 'Wybrane',
    role_details: 'Szczegóły roli',
    error_name_already_taken: 'Istnieje już rola z podaną nazwą.',
    toast_saved: 'Pomyślnie zapisano dane roli',
    toast_added: 'Pomyślnie dodano rolę',
    toast_deleted: 'Pomyślnie usunięto rolę',
    toast_delete_error: 'Nie można usunąć roli, ponieważ jest przypisana do aktywnych użytkowników',
  },
  permissions: {
    USER_MANAGEMENT: 'Zarządzanie użytkownikami',
    ROLE_MANAGEMENT: 'Zarządzanie rolami',
    CHANGE_CUSTOMER: 'Zmiana klienta',
    ANIMAL_MANAGEMENT: 'Zarządzanie zwierzętami',
    DIVISION_MANAGEMENT: 'Zarządzanie oddziałami',
    HOST_MANAGEMENT: 'Zarządzanie hostami',
    SCALE_MANAGEMENT: 'Zarządzanie wagami',
    PRINTER_MANAGEMENT: 'Zarządzanie drukarkami',
    IO_MANAGEMENT: 'Zarządzanie urządzeniami I/O',
    RAW_MATERIAL_MANAGEMENT: 'Zarządzanie surowcami',
    INGREDIENT_MANAGEMENT: 'Zarządzanie składnikami',
    RECIPE_MANAGEMENT: 'Zarządzanie recepturami',
    ORDER_MANAGEMENT: 'Zarządzanie zleceniami produkcji',
    VIEW_DOSAGE_REPORTS: 'Podgląd raportów dozowania',
    CUSTOMER_MANAGEMENT: 'Zarządzanie klientami',
    GROUP_TEMPLATES_MANAGEMENT: 'Zarządzanie szablonami grup',
    GROUPS_MANAGEMENT: 'Zarządzanie grupami I/O',
    LICENSE_MANAGEMENT: 'Zarządzanie licencjami',
    IO_PIN_VIEW: 'Podgląd pinów I/O',
    IO_PIN_EDIT: 'Edycja pinów I/O',
    IO_PIN_EDIT_ALL: 'Edycja wszystkich pinów I/O',
    // <%-enPermissionTranslation%>
  },
  animals: {
    header: 'Zwierzęta',
    description: 'Opis',
    rfid: 'RFID',
    empty_message: 'Brak zwierząt spełniających podane kryteria.',
    animal_details: 'Szczegóły zwierzęcia',
    error_name_already_taken: 'Istnieje już zwierzę z podaną nazwą.',
    error_rfid_already_taken: 'Istnieje już zwierzę z podanym RFID.',
    division: 'Oddział',
    error_division_required: 'Oddział jest wymagany',
    error_rfid_required: 'RFID jest wymagany',
    toast_saved: 'Pomyślnie zapisano dane zwierzęcia',
    toast_added: 'Pomyślnie dodano zwierzęcia',
    toast_deleted: 'Pomyślnie usunięto zwierzę',
  },
  printers: {
    header: 'Drukarki',
    description: 'Opis',
    empty_message: 'Brak drukarek spełniających podane kryteria.',
    printer_details: 'Szczegóły drukarki',
    error_name_already_taken: 'Istnieje już drukarka z podaną nazwą.',
    connection_type: 'Typ połączenia',
    ip_address: 'Adres IP',
    port: 'Port',
    port_path: 'Adres portu',
    baud_rate: 'Szybkość transmisji',
    databits: 'Bity danych',
    stopbits: 'Bity stopu',
    flow_control: 'Kontrola przepływu',
    parity: 'Parzystość',
    product_id: 'Identyfikator produktu',
    vendor_id: 'Identyfikator dostawcy',
    division: 'Oddział',
    host: 'Host',
    communication_protocol: 'Protokół komunikacji',
    zpl_content: 'Skrypt ZPL',
    hosts_empty_message: 'Brak aktywnych hostów w systemie',
    divisions_empty_message: 'Brak aktywnych oddziałów w systemie',
    error_connection_type_required: 'Typ połączenia jest wymagany',
    error_invalid_ip_address: 'Nieprawidłowy adres IP',
    error_ip_address_required: 'Adres IP jest wymagany',
    error_port_required: 'Port jest wymagany',
    error_port_path_required: 'Adres portu jest wymagany',
    error_baud_rate_required: 'Sybkość transmisji jest wymagana',
    error_vendor_id_required: 'Identyfikator dostawcy jest wymagany',
    error_product_id_required: 'Identyfikator produktu jest wymagany',
    error_ip_address_already_taken: 'Istnieje już drukarka z podanym adresem IP i portem dla danego hosta.',
    error_port_path_already_taken: 'Istnieje już drukarka z podanym portem dla danego hosta.',
    error_vendor_id_product_id_already_taken:
      'Istnieje już drukarka z podanym identyfikatorem dostawcy i produktu dla danego hosta.',
    error_different_host: 'Drukara i waga muszą być przypisane do tego samego hosta.',
    error: 'Błąd podczas drukowania',
    errors: {
      UNKNOWN_ERROR: 'Nieznany błąd',
      SERVER_TIMEOUT: 'Przekroczono limit czasu na odpowiedź hosta',
      CONNECTION_ERROR: 'Nie udało się nawiązać połączenia z drukarką',
      COMMUNICATION_ERROR: 'Drukarka nie odpowiedziała poprawnie na komendę ',
      COVER_IS_OPEN_ERROR: 'Pokrywa papieru jest otwarta',
      PAPER_END_ERROR: 'Brak papieru',
      NOT_FOUND: 'Brak drukarki przypisanej do wagi',
      PRINTER_NOT_FOUND: 'Drukarka nie została odnaleziona',
    },
  },
  rawMaterials: {
    header: 'Surowce',
    report_header: 'Raport surowców',
    empty_message: 'Brak surowców spełniających podane kryteria.',
    raw_material_details: 'Szczegóły surowca',
    error_name_already_taken: 'Istnieje już surowiec z podaną nazwą.',
    usage: 'Zużycie',
    report_name: 'Raport zużycia surowców',
    toast_saved: 'Pomyślnie zapisano dane surowca',
    toast_added: 'Pomyślnie dodano surowiec',
    toast_deleted: 'Pomyślnie usunięto surowiec',
    connectors: 'Wyjścia',
    select_connectors: 'Wybierz wyjścia',
  },
  ingredients: {
    header: 'Składniki',
    empty_message: 'Brak składników spełniających podane kryteria.',
    ingredient_details: 'Szczegóły składnika',
    error_name_already_taken: 'Istnieje już składnik z podaną nazwą.',
    raw_materials_empty_message: 'Brak aktywnych surowców w systemie',
    pin_number: 'Wyjście sterujące',
    raw_material: 'Surowiec',
    error_pin_number_required: 'Wyjście sterujące jest wymagane',
    error_raw_material_required: 'Surowiec jest wymagany',
    error_pinNumber_already_taken: 'Istnieje już składnik z podanym numerem numerem składnika.',
    toast_saved: 'Pomyślnie zapisano dane składnika',
    toast_added: 'Pomyślnie dodano składnik',
    toast_deleted: 'Pomyślnie usunięto składnik',
    delete_error_ingredient_in_use: 'Nie można usunąć składnika, ponieważ jest używany w recepturze',
  },
  recipes: {
    header: 'Receptury',
    empty_message: 'Brak receptur spełniających podane kryteria.',
    recipe_details: 'Szczegóły receptury',
    error_name_already_taken: 'Istnieje już receptura z podaną nazwą.',
    toast_saved: 'Pomyślnie zapisano dane receptury',
    toast_added: 'Pomyślnie dodano recepturę',
    toast_deleted: 'Pomyślnie usunięto recepturę',
    toast_make_default: 'Pomyślnie oznaczono recepturę jako domyślną',
    is_default: 'Domyślna',
    makeDefault: 'Ustaw jako domyślną',
    useActive: 'Użyj wyjścia "Aktywne"',
    delayForFinished: 'Opóżnienie dla wyjścia "Zakończono"',
  },
  recipeIngredients: {
    ingredient: 'Składnik',
    quantity: 'Ilość',
    sequence_number: 'Kolejność',
    delay: 'Opóźnienie',
    error_ingredient_required: 'Składnik jest wymagany',
    error_quantity_required: 'Ilość jest wymagana',
    error_sequence_number_required: 'Kolejność jest wymagana',
    error_sequence_number_unique: 'Kolejność musi być unikalna',
    error_sequenceNumber_already_taken: 'Istnieje już składnik z podaną kolejnością.',
    ingredients_empty_message: 'Brak aktywnych składników w systemie',
  },
  orders: {
    header: 'Zlecenia produkcji',
    empty_message: 'Brak zleceń produkcji spełniających podane kryteria.',
    order_details: 'Szczegóły zlecenia produkcji',
    error_name_already_taken: 'Istnieje już zlecenie produkcji z podaną nazwą.',
    error_another_order_in_progress: 'Inne zlecenie produkcji jest w trakcie',
    toast_added: 'Pomyślnie wystartowano zlecenie produkcji',
    recipe: 'Receptura',
    scale: 'Waga',
    status: 'Status',
    start_date: 'Czas rozpoczęcia',
    end_date: 'Czas zakończenia',
    statuses: {
      IN_PROGRESS: 'W trakcie',
      PAUSED: 'Wstrzymane',
      CANCELLED: 'Anulowane',
      FINISHED: 'Zakończone',
    },
  },
  orderIngredients: {
    order: 'Zlecenie produkcji',
    ingredient: 'Składnik',
    pin_number: 'Wyjście sterujące',
    quantity: 'Ilość',
    expected_quantity: 'Oczekiwana ilość',
    actual_quantity: 'Faktyczna ilość',
    sequence_number: 'Kolejność',
    delay: 'Opóźnienie',
  },
  customers: {
    header: 'Klienci',
    empty_message: 'Brak klientów spełniających podane kryteria.',
    customer_details: 'Szczegóły klienta',
    error_name_already_taken: 'Istnieje już klient z podaną nazwą.',
    first_name: 'Imię',
    last_name: 'Nazwisko',
    tax_id: 'NIP',
    comment: 'Komentarz',
    toast_saved: 'Pomyślnie zapisano dane klienta',
    toast_added: 'Pomyślnie dodano klienta',
    toast_deleted: 'Pomyślnie usunięto klienta',
  },
  io: {
    header: 'Urządzenia I/O',
    empty_message: 'Brak urządzeń spełniających podane kryteria.',
    io_details: 'Szczegóły urządzenia',
    error_name_already_taken: 'Istnieje już urządzenie z podaną nazwą.',
    error_ipAddress_already_taken: 'Istnieje już urządzenie z podanym adresem IP.',
    error_division_required: 'Oddział jest wymagany',
    error_invalid_ip_address: 'Nieprawidłowy adres IP',
    error_ip_address_required: 'Adres IP jest wymagany',
    description: 'Opis',
    host: 'Host',
    division: 'Oddział',
    model: 'Model',
    ip_address: 'Adres IP',
    hosts_empty_message: 'Brak aktywnych hostów w systemie',
    toast_saved: 'Pomyślnie zapisano dane urządzenia',
    toast_added: 'Pomyślnie dodano urządzenie',
    toast_deleted: 'Pomyślnie usunięto urządzenie',
  },
  groupTemplates: {
    header: 'Szablony grup I/O',
    empty_message: 'Brak szablonów spełniających podane kryteria.',
    group_template_details: 'Szczegóły szablonu',
    group_template_params: 'Parametry szablonu',
    error_name_already_taken: 'Istnieje już szablon z podaną nazwą.',
    division: 'Oddział',
    toast_saved: 'Pomyślnie zapisano dane szablonu',
    toast_added: 'Pomyślnie dodano szablon',
    toast_deleted: 'Pomyślnie usunięto szablon',
    connectors: 'Wejścia/Wyjścia',
    input: 'Wejście',
    output: 'Wyjście',
    error_connector_name_duplicated: 'Nazwa musi być unikalna',
    error_division_required: 'Oddział jest wymagany',
    error_outputs_required: 'Liczba wyjść jest wymagana',
    template_type_required: 'Typ szablonu jest wymagany',
    is_used: 'Użyty',
    type_THR: 'THR',
    type_dosage: 'Dozowanie',
    generate: 'Wygeneruj',
    outputs_count: 'Liczba wyjść',
    inputs_count: 'Liczba wejść',
  },
  groups: {
    header: 'Grupy I/O',
    empty_message: 'Brak grup spełniających podane kryteria.',
    group_details: 'Szczegóły grupy',
    error_name_already_taken: 'Istnieje już grupa z podaną nazwą.',
    division: 'Oddział',
    group_template: 'Szablon grupy',
    group_templates_empty_message: 'Brak aktywnych grup w systemie',
    toast_saved: 'Pomyślnie zapisano dane grupy',
    toast_added: 'Pomyślnie dodano grupę',
    toast_deleted: 'Pomyślnie usunięto grupę',
    io_device: 'Urządzenie I/O',
    pin: 'Pin',
    error_division_required: 'Oddział jest wymagany',
    error_io_device_same_host: 'Wybrane urządzenia I/O muszą być przypisane do tego samego hosta',
    error_group_template_required: 'Szablon grupy jest wymagany',
    error_pin_in_use: 'Pin musi być unikalny',
    error_io_device_required: 'Urządzenie I/O jest wymagane',
    error_pin_required: 'Pin jest wymagany',
    connector_erors: {
      pin_invalid: 'Pin jest niepoprawny',
      pin_duplicate: 'Pin musi być unikalny',
    },
  },
  licenses: {
    header: 'Licencje',
    empty_message: 'Brak licencji spełniających podane kryteria.',
    license_details: 'Szczegóły licencji',
    error_name_already_taken: 'Istnieje już licencja z podaną nazwą.',
    customer: 'Klient',
    type: 'Typ',
    email: 'Email',
    device_key: 'Identyfikator instalacji',
    license_key: 'Klucz licencyjny',
    version: 'Wersja',
    installation_name: 'Nazwa wdrożenia',
    expiration_date: 'Data wygaśnięcia',
    limits: 'Limity',
    users_number: 'Liczba użytkowników',
    scales_number: 'Liczba wag',
    comment: 'Komentarz',
    error_customer_required: 'Klient jest wymagany',
    error_type_required: 'Typ jest wymagany',
    error_license_key_required: 'Klucz licencyjny jest wymagany',
    error_customers_empty_message: 'Brak aktywnych licencji w systemie',
    error_device_key_length: 'Identyfikator instalacji musi mieć 64 znaki',
    error_device_key_hexadecimal: 'Identyfikator instalacji musi być wartością szesnastkową',
    toast_saved: 'Pomyślnie zapisano dane licencji',
    toast_added: 'Pomyślnie dodano licencję',
    toast_deleted: 'Pomyślnie usunięto licencję',
    toast_copied: 'Pomyślnie skopiowano klucz licencyjny do schowka',
    copyToClipboard: 'Skopiuj klucz licencyjny do schowka',
    enums: {
      OFFLINE: 'Offline',
      ONLINE: 'Online',
    },
  },
  verifyLicenseKeyPage: {
    menuHeader: 'Zaktualizuj klucz licencyjny',
    header: 'Klucz Scalescloud Offline',
    invalidLicenseKeyError: 'Niepoprawny klucz licencyjny',
    expiredLicenseError: 'Ta licencja wygasła',
    versionMismatchError: 'Ta licencja nie jest przeznaczona dla Twojej wersji aplikacji',
    verifyKey: 'Zweryfikuj klucz',
    showInstallationKey: 'Pokaż klucz instalacyjny',
    deviceKey: 'Klucz urządzenia',
    copy: 'Kopiuj',
    dataCopied: 'Skopiowano do schowka',
    licenseUpdated: 'Pomyślnie zaktualizowano klucz licencyjny',
  },
  scalesIndicationsDashboard: {
    back: 'Powrót',
  },
  pins: {
    header: 'Sterowanie I/O',
    status: 'Status',
    io_name: 'Nazwa urządzenia I/O',
    pin: 'Pin',
    empty_message: 'Brak urządzeń I/O do sterowania.',
    statuses: {
      0: 'OFF',
      1: 'ON',
      ERROR: 'BŁĄD',
      TIMEOUT: 'BRAK ODPOWIEDZI IO',
      SERVER_TIMEOUT: 'BRAK ODPOWIEDZI HOSTA',
    },
    pin_toggled: 'Pomyślnie zmieniono stan pinu na ',
    pin_toggle_error: 'Błąd podczas zmiany stanu pinu',
  },
  // <%-enTranslations%>
};
